import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { PropsWithChildren } from "react";

type GroupedFilesOverlayProps = PropsWithChildren<{
  count: number;
  onClick: (e: React.MouseEvent) => void;
}>;

const OverlayContainer = styled("div")({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const Overlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.6)",
  color: theme.palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2,
  borderRadius: 6,
  pointerEvents: "auto",
  userSelect: "none",
  cursor: "zoom-in",
  transition: "background 0.3s ease",

  "&:hover": {
    background: "rgba(0,0,0,0.3)",
  },
}));

export const GroupedFilesOverlay = (props: GroupedFilesOverlayProps) => {
  const { count, children, onClick } = props;
  return (
    <OverlayContainer>
      {children}
      <Overlay onClick={onClick}>
        <Typography
          variant="large"
          sx={{
            fontWeight: "bold",
          }}
        >
          +{count}
        </Typography>
      </Overlay>
    </OverlayContainer>
  );
};
